<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/event"
                saveRoot="/event"
                @onInitSuccess="onInitSuccess"
                @onSave="onSave"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.event">
            <slot slot="afterFormButtons">
                <b-button @click="onReplaceEventDatesClick" class="ml-2" type="button" variant="success">
                    {{Core.Definition.getDefinition('Enr. et remplacer')}}
                </b-button>
            </slot>
            <slot slot="reminder">
                <Reminder v-model="dataReminder"></Reminder>
            </slot>
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/event"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'événement')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet événement?')"></ModalTrash>

        <Modal
                ref="modalReplaceEventDates"
                :caption="Core.Definition.getDefinition('Enregistrer et remplacer le calendrier')"
                :hideFooter="true">
            <slot slot="body">
                <DynamicForm
                        v-model="dataId"
                        ref="dynamicFormReplaceEventDates"
                        getRoot="/event/replace"
                        saveRoot="/event"
                        @onSave="onSaveReplaceEventDates"
                        :options="{
                            submit: {
                                text: 'Enregistrer et remplacer',
                                variant: 'primary'
                            }
                        }"
                        :formStructure="dataFormStructures.replace">
                    <slot slot="beforeForm">
                        <b-alert show variant="info">
                            {{Core.Definition.getDefinition('Les événements futurs dans le calendrier seront mis à jour avec les nouvelles informations. Sélectionnez ci-dessous les informations que vous désirez remplacer.')}}
                        </b-alert>
                    </slot>
                </DynamicForm>
            </slot>
        </Modal>

        <ModalInstanceSelector
                :caption="Core.Definition.getDefinition('Liste des adresses')"
                ref="modalInstanceSelectorAddress"
                root="/address/list"
                v-model="dataAddress"
                :multiple="false"
                :distinct="true"
                :searchFormStructure="{
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'id'
                                                }
                                            ]
                                        },
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'id',
                                    type: 'number',
                                    label: Core.Definition.getDefinition('ID'),
                                    value: ''
                                },
                                {
                                    id: 'title',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Titre'),
                                    value: ''
                                }
                            ]
                        }"
                :options="{
                                pagination: true,
                                header: true,
                                responsive: false,
                                striped: true,
                                headerStyle: '1',
                                emptyText: Core.Definition.getDefinition('Aucune adresse à afficher'),
                                borderVariant: 'white',
                                noBody: true
                         }"
                :columns="[
                                {
                                    label: Core.Definition.getDefinition('ID'),
                                    key: 'id',
                                    sortable: true
                                },
                                {
                                    label: Core.Definition.getDefinition('Titre'),
                                    key: 'title',
                                    sortable: true
                                }
                         ]">
        </ModalInstanceSelector>
    </div>
</template>

<script>
    var _self
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import Modal from '../../components/Modal'
    import InputCheckbox from '../../components/InputCheckbox'
    import ModalInstanceSelector from '../../components/ModalInstanceSelector'
    import Reminder from '../../components/Reminder'
    export default {
        name: 'Event',
        components: {
            DynamicForm,
            ModalTrash,
            Modal,
            InputCheckbox,
            ModalInstanceSelector,
            Reminder
        },
        watch: {
            dataAddress(val) {
                this.$refs.dynamicForm.$refs.form.fieldRefs['address'].dataValue = val[0].instance.address
                this.$refs.dynamicForm.$refs.form.fieldRefs['place'].dataValue = val[0].instance.place
                this.$refs.dynamicForm.$refs.form.fieldRefs['districtId'].dataValue = Core.Select.select(val[0].instance.districtId, this.$refs.dynamicForm.$refs.form.fieldRefs['districtId'].getOptions())
            }
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataReminder: {
                    times: [],
                    model: {
                        option: Mantle.Reminder.modelSystemConfig,
                        text: ''
                    }
                },
                dataAddress: [],
                dataRequiredProducts: [],
                dataFormStructures: {
                    replace: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Informations de l\'événement'),
                                                options: { class: 'card-no-border' },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceAll'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceTitle'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceDescription'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceType'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceIsVirtual'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceAssignedUsers'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceLocal'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceRequiredProducts'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceForcePurchase'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },

                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceMax'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceMin'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceBookingIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceWaitingListIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceBookingTimeStart'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceBookingTimeEnd'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceFormTemplateId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceReminder'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'replaceColor'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'replaceAll',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Sélectionner tous'),
                                value: false,
                                labelCols: 6,
                                onChange: function(val, form, fieldRefs) {
                                    fieldRefs['replaceTitle'].dataValue = val
                                    fieldRefs['replaceDescription'].dataValue = val
                                    fieldRefs['replaceType'].dataValue = val
                                    fieldRefs['replaceIsVirtual'].dataValue = val
                                    fieldRefs['replaceAssignedUsers'].dataValue = val
                                    fieldRefs['replaceRequiredProducts'].dataValue = val
                                    fieldRefs['replaceLocal'].dataValue = val
                                    fieldRefs['replaceForcePurchase'].dataValue = val
                                    fieldRefs['replaceColor'].dataValue = val
                                    fieldRefs['replaceMin'].dataValue = val
                                    fieldRefs['replaceMax'].dataValue = val
                                    fieldRefs['replaceBookingTimeStart'].dataValue = val
                                    fieldRefs['replaceBookingTimeEnd'].dataValue = val
                                    fieldRefs['replaceBookingIsEnabled'].dataValue = val
                                    fieldRefs['replaceWaitingListIsEnabled'].dataValue = val
                                    fieldRefs['replaceFormTemplateId'].dataValue = val
                                    fieldRefs['replaceReminder'].dataValue = val
                                }
                            },
                            {
                                id: 'replaceTemplates',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Remplacer les modèles enregistrées'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceTitle',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Titre'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceDescription',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Description'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceType',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Type'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceIsVirtual',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Virtuel'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceAssignedUsers',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Responsable'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceRequiredProducts',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Produit requis'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {

                                }
                            },
                            {
                                id: 'replaceLocal',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Local'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceForcePurchase',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Forcer l\'achat lors de la réservation'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceColor',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Couleur'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceMin',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Min'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceMax',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Max'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceBookingTimeStart',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Ouverture des réservations'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceBookingTimeEnd',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Fermeture des réservations'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceBookingIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Réservation autorisée'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceWaitingListIsEnabled',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Liste d\'attente autorisée'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceFormTemplateId',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Formulaire'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            },
                            {
                                id: 'replaceReminder',
                                type: 'checkbox',
                                label: Core.Definition.getDefinition('Rappel'),
                                value: false,
                                onChange: function(val, form, fieldRefs) {
                                }
                            }
                        ]
                    },
                    event: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Général'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'type'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'assignedUsers'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'color'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'leagueId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Réservation'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingIsEnabled'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'waitingListIsEnabled'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'formTemplateId'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'max'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingTimeStart'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'bookingTimeEnd'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Produit'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'requiredProducts'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'forcePurchase'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Rappels automatiques'),
                                                subCaption: Core.Definition.getDefinition('Les rappels seront envoyés aux participants de l\'événement'),
                                                key: 'reminder'
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Emplacement'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'isVirtual'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'selectExistingAddress'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'address'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'districtId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'local'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'cityId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'isVirtual',
                                type: Core.Value.typeCheckbox,
                                labelCols: 2,
                                label: Core.Definition.getDefinition('Événement virtuel'),
                                value: null,
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.virtualEventIsEnabled'),'checkbox'),
                                onChange: function(val, form, fieldRefs) {
                                    if(val === true) {
                                        fieldRefs['max'].dataValue = 10
                                        fieldRefs['max'].dataReadOnly = true
                                        //fieldRefs['min'].dataValue = 1
                                        //fieldRefs['min'].dataReadOnly = true
                                        fieldRefs['local'].isVisible = false

                                        if (Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')) {
                                            fieldRefs['address'].isVisible = false
                                            fieldRefs['districtId'].isVisible = false
                                            fieldRefs['cityId'].isVisible = false
                                            fieldRefs['selectExistingAddress'].isVisible = false
                                        }
                                    } else {
                                        fieldRefs['max'].dataReadOnly = false
                                        //fieldRefs['min'].dataReadOnly = false
                                        fieldRefs['local'].isVisible = true

                                        if (Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')) {
                                            fieldRefs['address'].isVisible = true
                                            fieldRefs['districtId'].isVisible = true
                                            fieldRefs['cityId'].isVisible = true
                                            fieldRefs['selectExistingAddress'].isVisible = true
                                        }
                                    }
                                }
                            },
                            {
                                id: 'type',
                                type: Core.Value.typeSelect,
                                label: Core.Definition.getDefinition('Type'),
                                value: null,
                                required: true,
                                onSelect: function() {}
                            },
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: '',
                                required: true
                            },
                            {
                                id: 'requiredProducts',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Produits requis'),
                                value: null,
                                onSelect: function(val) {}
                            },
                            {
                                id: 'forcePurchase',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Forcer l\'achat lors de la réservation'),
                                description: Core.Definition.getDefinition('Si cette option n\'est pas activée, les usagers pourront réserver même s\'ils ne détiennent pas l\'un des produits requis. Toutefois, vous serez notifié dans le panneau des réservations que l\'usagé ne détient pas de produit requis.'),
                                value: false,
                                onChange: function() {}
                            },
                            {
                                id: 'formTemplateId',
                                type: 'select',
                                label: Core.Definition.getDefinition('Formulaire'),
                                description: Core.Definition.getDefinition('Formulaire que l\'usager doit compléter avant de réserver.'),
                                value: null,
                                onSelect: function(val) {}
                            },
                            {
                                id: 'min',
                                type: 'quantity',
                                label: Core.Definition.getDefinition('Min.'),
                                value: '0'
                            },
                            {
                                id: 'max',
                                type: 'quantity',
                                label: Core.Definition.getDefinition('Max.'),
                                value: '0',
                                description: Core.Definition.getDefinition('Ignoré si 0. Si une réservation est effectuée et que le maximum est atteint, l\'usagé sera placé en liste d\'attente et sera notifié.'),

                            },
                            {
                                id: 'bookingTimeStart',
                                type: 'time',
                                label: Core.Definition.getDefinition('Ouverture des réservations avant l\'heure de l\'événement'),
                                value: ''
                            },
                            {
                                id: 'bookingTimeEnd',
                                type: 'time',
                                label: Core.Definition.getDefinition('Fermeture des réservations avant l\'heure de l\'événement'),
                                value: ''
                            },
                            {
                                id: 'description',
                                type: 'editor',
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            },
                            {
                                id: 'assignedUsers',
                                type: 'multiSelect',
                                label: Core.Definition.getDefinition('Responsables'),
                                description: Core.Definition.getDefinition('Pour les événements virtuels, les responsables sont les présentateurs.'),
                                value: null,
                                onSelect: function() {}
                            },
                            {
                                id: 'color',
                                type: Core.Value.typeColor,
                                mode: 'sketchCompact',
                                label: Core.Definition.getDefinition('Couleur'),
                                value: {}
                            },
                            {
                                id: 'status',
                                type: Core.Value.typeSelect,
                                description: Core.Definition.getDefinition('État par défaut lorsque l\'événement sera ajouté au calendrier. L\'état peut être changé durant la création du calendrier.'),
                                label: Core.Definition.getDefinition('État par défaut'),
                                value: Core.Select.select(Core.Instance.statusDraft, Core.Instance.statusOptions()),
                                onSelect: function() {},
                                required: true
                            },
                            {
                                id: 'local',
                                type: 'text',
                                label: Core.Definition.getDefinition('Local'),
                                value: ''
                            },
                            {
                                id: 'bookingIsEnabled',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Réservation autorisée'),
                                value: true,
                                onChange: function() {}
                            },
                            {
                                id: 'waitingListIsEnabled',
                                type: Core.Value.typeCheckbox,
                                label: Core.Definition.getDefinition('Liste d\'attente autorisée'),
                                value: true,
                                onChange: function() {}
                            },
                            {
                                id: 'districtId',
                                type: Core.Value.typeSelect,
                                label: Core.Definition.getDefinition('Région'),
                                value: null,
                                onSelect: function() {},
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')
                            },
                            {
                                id: 'cityId',
                                type: Core.Value.typeSelect,
                                label: Core.Definition.getDefinition('Ville'),
                                value: null,
                                onSelect: function() {},
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')
                            },
                            {
                                id: 'address',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                                value: '',
                                description: Core.Definition.getDefinition('Entrez une adresse valide pour la localisation Google Map (Format: Numéro, rue, ville, code postal)'),
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox')
                            },
                            {
                                id: 'leagueId',
                                type: Core.Value.typeMultiSelect,
                                label: Core.Definition.getDefinition('Ligue'),
                                value: null,
                                onSelect: function() {},
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.leagueIsEnabled'),'checkbox')
                            },
                            {
                                id: 'selectExistingAddress',
                                type: 'actionButton',
                                label: Core.Definition.getDefinition('Choisir un lieu enregistré'),
                                value: null,
                                isVisible: Core.Value.encode(Core.Session.Setting.getSetting('event.placeIsEnabled'),'checkbox'),
                                onClick: function() {
                                    _self.$refs.modalInstanceSelectorAddress.open = true
                                }
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onInitSuccess(data) {
                if(data.form !== undefined && data.form.reminder !== undefined) {
                    this.dataReminder = data.form.reminder
                }
            },
            onSave() {
                this.$refs.dynamicForm.addSaveArg('reminder', this.dataReminder)
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/evenement/evenements')
            },
            onReplaceEventDatesClick() {
                this.$refs.modalReplaceEventDates.open = true
            },
            onSaveReplaceEventDates() {
                this.$refs.dynamicFormReplaceEventDates.addSaveArg('saveNReplace', '1')
                this.$refs.dynamicFormReplaceEventDates.addSaveArg('reminder', this.dataReminder)
                let form = this.$refs.dynamicForm.$refs.form.form
                for(let key in form) {
                    let field = Core.Array.findByKey(this.dataFormStructures.event.fields, 'id', key)
                    let value = form[key]
                    this.$refs.dynamicFormReplaceEventDates.addSaveArg(key, value, field.type)
                }
            },
            onRequestReplaceEventDatesSuccess(data) {
            },
            clickEdit() {
            }
        }
    }
</script>
